module.exports = __webpack_public_path__ + "static/media/40-web-or-mls-DSC06857.33208342.jpg";